import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../../common/method/handleNotificationAlert'

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
    SelectStatusCkeckQuestin: "SelectStatusCkeckQuestin [Action]",
    SelectStatusCkeckQuestinLoading: "SelectStatusCkeckQuestinLoading [Action]",
    SelectStatusCkeckQuestinAsync: "SelectStatusCkeckQuestinAsync [Action]",
};
const inistiaState = {
    data: {},
    loading: false
};

export const reducerSelecStatusCkeckQuestint = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectStatusCkeckQuestin:
            return {
                ...state,
                data: payload,
            };
        case actionTypes.SelectStatusCkeckQuestinLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectStatusCkeckQuestinLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "questionnaire",
        method_type: "check_questionnaires_completion_status",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.SelectStatusCkeckQuestin, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectStatusCkeckQuestinLoading, payload: false })

    }
}

export function* selectStatusCkeckQuestint() {
    yield takeLatest(actionTypes.SelectStatusCkeckQuestinAsync, handleWorker);
}
